import BaseApi from './BaseApi'

export default class DeviceEventApi extends BaseApi {
    async getDeviceEvents (params = {
        dateFrom: null,
        dateTo: null,
        vehicleId: null,
        page: null,
        recordLimit: null,
        vehicleRegistrationNumber: null,
        eventClassifications: null,
        eventTypes: null,
        driverId: null,
    }) {
        const request = new URLSearchParams();

        if (params.page) {
            request.append('Page', params.page);
        }

        if (params.recordLimit) {
            request.append('RecordLimit', params.recordLimit);
        }

        if (params.dateFrom) {
            request.append('DateFrom', params.dateFrom);
        }

        if (params.dateTo) {
            request.append('DateTo', params.dateTo);
        }

        if (params.vehicleRegistrationNumber) {
            request.append('VehicleRegistrationNumber', params.vehicleRegistrationNumber);
        }

        if (params.driverId) {
            request.append('DriverId', params.driverId);
        }

        if (params.vehicleId) {
            request.append('VehicleId', params.vehicleId);
        }

        if (params.eventCategories) {
            params.eventCategories.forEach((item) => {
                request.append('EventCategories', item);
            })
        }

        if (params.eventClassifications) {
            params.eventClassifications.forEach((item) => {
                request.append('EventClassifications', item);
            })
        }

        if (params.eventTypes) {
            params.eventTypes.forEach((item) => {
                request.append('EventTypes', item);
            })
        }

        return  await this.get(`/api/v1.0/devicesEvents`, request)
    }
    async getDeviceEventMedia (id, hardwareId, eventId) {
        return await this.get(`/api/v1.0/devicesEvents/${hardwareId}/event/${id}/media`, {
            EventId: eventId,
            HardwareId: hardwareId
        })
    }
    async getDeviceEvent (id, hardwareId) {
        return await this.get(`/api/v1.0/devicesEvents/${hardwareId}/event/${id}`)
    }
    async uploadMedia (file) {
        return this.post('/api/v1.0/devicesEvents', file)
    }
}
